import { Button, DropdownMenu } from 'components/atoms';
import { useComponentVisible } from 'hooks';
import { useTranslation } from 'react-i18next';
import { PiArrowsClockwise } from 'react-icons/pi';

interface ILabelReportButtonGenerateProps {
  id: string;
  alignTop?: boolean;
  canGenerateDetailedReport: boolean;
  isLoadingSimple: boolean;
  isLoadingDetailed: boolean;
  onGenerateSimple: (id: string) => void;
  onGenerateDetailed: (id: string) => void;
}

const LabelReportButtonGenerate = ({
  id,
  alignTop,
  canGenerateDetailedReport,
  isLoadingSimple,
  isLoadingDetailed,
  onGenerateSimple,
  onGenerateDetailed,
}: ILabelReportButtonGenerateProps) => {
  const { t } = useTranslation();
  const { ref, isComponentVisible, handleComponentVisible } =
    useComponentVisible<HTMLDivElement>(false);
  const handleGenerateSimple = () => {
    if (isComponentVisible) {
      handleComponentVisible();
    }
    onGenerateSimple(id);
  };
  const handleGenerateDetailed = () => {
    if (isComponentVisible) {
      handleComponentVisible();
    }
    onGenerateDetailed(id);
  };

  return (
    <Button
      isClear
      onlyIcon
      isLoading={isLoadingSimple || isLoadingDetailed}
      onClick={handleComponentVisible}
      outsideChildren={
        <DropdownMenu
          ref={ref}
          visible={isComponentVisible}
          style={{ padding: 0 }}
          align={alignTop ? 'top' : 'bottom'}
          justifyPosition='end'>
          <Button
            type='button'
            isClear
            fullWidth
            size='compact'
            onClick={handleGenerateSimple}
            buttonStyle={{ justifyContent: 'start' }}
            isLoading={isLoadingSimple}>
            <Button.Icon icon={<PiArrowsClockwise />} />
            <Button.Text text={t('button.simple')} />
          </Button>
          {canGenerateDetailedReport && (
            <Button
              type='button'
              isClear
              fullWidth
              size='compact'
              onClick={handleGenerateDetailed}
              buttonStyle={{ justifyContent: 'start' }}
              isLoading={isLoadingDetailed}>
              <Button.Icon icon={<PiArrowsClockwise />} />
              <Button.Text text={t('button.detail')} />
            </Button>
          )}
        </DropdownMenu>
      }>
      <Button.Description description={t('button.refresh')} />
      <Button.Icon icon={<PiArrowsClockwise />} />
    </Button>
  );
};

export default LabelReportButtonGenerate;
